import { Component } from '@angular/core';
import { GuestAnatomyComponent } from '../components/guest-anatomy/guest-anatomy.component';
import { GuestElementsComponent } from '../components/guest-elements/guest-elements.component';
import { GuestPartnersComponent } from '../components/guest-partners/guest-partners.component';
import { GuestTeacherResourcesComponent } from '../components/guest-teacher-resources/guest-teacher-resources.component';

@Component({
  selector: 'stars-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.scss'],
  imports: [
    GuestAnatomyComponent,
    GuestElementsComponent,
    GuestPartnersComponent,
    GuestTeacherResourcesComponent
  ]
})
export class GuestPageComponent {}
